export const translations = {
  // ─────────────────────────────────────────
  //  ENGLISH (default)
  // ─────────────────────────────────────────
  en: {
    // NAVBAR
    nav_healthcare: 'Healthcare',
    nav_home_support: 'Home Support',
    nav_personal_support: 'Personal Support',
    nav_how_it_works: 'How It Works',
    nav_for_providers: 'For Providers',
    nav_find_caregiver: 'Find a Caregiver',
    nav_sign_in: 'Sign in',
    download_android: 'Download for Android',
    download_ios: 'Download for iOS',

    // HERO
    hero_badge: 'Trusted by 40,000+ families across India & Europe',
    hero_headline: 'Care that feels like',
    hero_headline_em: 'family',
    hero_sub: 'Find verified nurses, caregivers, home helpers, and counselors — handpicked, background-checked, and ready to help when you need it most.',
    hero_search_placeholder: 'What kind of care are you looking for?',
    hero_search_btn: 'Search',
    hero_trust_verified: 'Background Verified',
    hero_trust_insured: 'Insured',
    hero_trust_rating: 'Avg 4.9 Rating',

    // HERO FLOATING CARDS
    hero_card_badge: '✓ Verified Nurse',
    hero_card_specialty: 'Post-Surgery Care • 8 yrs exp',
    hero_booking_status: 'Booking confirmed',
    hero_booking_service: 'Post-Surgery Care',
    hero_booking_time: 'Tomorrow, 9:00 AM - 5:00 PM',
    hero_booking_action: 'Caregiver on the way',
    hero_matched_label: 'Matched for you',
    hero_matched_distance: '2.5 km away',

    // QUICK FILTERS (array)
    quickFilters: ['Elderly Care', 'Post-Surgery Nurse', 'House Cleaning', 'Counseling', 'Child Care', 'Companion'],

    // CATEGORIES SECTION
    cat_overline: 'Our Services',
    cat_heading: 'Every kind of care, under one roof',
    cat_sub: 'From medical support to everyday help — choose the care that fits your life.',
    cat_providers_label: 'providers',
    cat_explore: 'Explore',

    cat1_title: 'Healthcare Support',
    cat1_desc: 'Professional medical care at home — from nursing to rehabilitation.',
    cat1_tags: ['Elderly care', 'Post-surgery', 'Dementia care', 'ICU support'],

    cat2_title: 'Home Support',
    cat2_desc: 'Trusted help for daily household tasks and family needs.',
    cat2_tags: ['Cleaning', 'Cooking', 'Grocery runs', 'Childminding'],

    cat3_title: 'Personal Support',
    cat3_desc: 'Emotional wellness, companionship, and guidance when you need it.',
    cat3_tags: ['Counseling', 'Life coaching', 'Companionship', 'Grief support'],

    // FEATURED PROVIDERS
    featured_overline: 'Featured Providers',
    featured_heading: 'Trusted by families like yours',
    featured_view_all: 'View all providers',
    badge_verified: '✓ Verified',

    // STATS
    stat_families: 'Families served',
    stat_rating: 'Average provider rating',
    stat_caregivers: 'Verified caregivers',
    stat_satisfaction: 'Satisfaction rate',

    // HOW IT WORKS
    how_heading: 'Care in 4 simple steps',
    how_step1_title: 'Describe your needs',
    how_step1_desc: "Tell us about the care you're looking for and any specific requirements.",
    how_step2_title: 'Browse matched providers',
    how_step2_desc: 'Review verified profiles, ratings, and reviews of caregivers who fit your needs.',
    how_step3_title: 'Connect & confirm',
    how_step3_desc: 'Message providers, discuss details, and book with confidence.',
    how_step4_title: 'Ongoing support',
    how_step4_desc: 'Receive quality care with our satisfaction guarantee and 24/7 support.',

    // TESTIMONIALS
    test_overline: 'What Families Say',
    test_heading: 'Stories of trust and care',

    // RECRUITMENT BANNER
    recruit_heading: 'Are you a caregiver, nurse, or counselor?',
    recruit_body: "Join India's fastest-growing care marketplace. Set your own schedule, connect with families who need you, and grow your practice.",
    perk_free: 'Free to join',
    perk_payouts: 'Instant payouts',
    perk_schedule: 'You set your schedule',
    perk_insurance: 'Liability insurance included',
    btn_become_provider: 'Become a Provider',
    btn_learn_more: 'Learn more',

    // FINAL CTA
    cta_heading: 'Your family deserves the very best care',
    cta_body: "Whether you need medical support, help around the house, or someone to talk to — we're here to connect you with trusted, verified caregivers.",
    btn_find_today: 'Find a Caregiver Today',
    btn_browse_services: 'Browse All Services',

    // FOOTER
    footer_tagline: "Connecting families with verified, compassionate caregivers across India and Europe. Trust, safety, and human connection — that's our promise.",
    footer_col_services: 'Services',
    footer_col_company: 'Company',
    footer_col_support: 'Support',
    footer_copyright: '© 2025 Lotus Care. All rights reserved.',
    footer_healthcare: 'Healthcare Support',
    footer_home_support: 'Home Support',
    footer_personal_support: 'Personal Support',
    footer_elderly: 'Elderly Care',
    footer_post_surgery: 'Post-Surgery Care',
    footer_about: 'About Us',
    footer_careers: 'Careers',
    footer_press: 'Press',
    footer_blog: 'Blog',
    footer_partners: 'Partners',
    footer_help: 'Help Center',
    footer_safety: 'Safety Center',
    footer_guidelines: 'Community Guidelines',
    footer_contact: 'Contact Us',
    footer_accessibility: 'Accessibility',

    // CATEGORY PAGE
    breadcrumb_home: 'Home',
    providers_available_suffix: '+ providers available',
    filters_title: 'Filters',
    price_range_label: 'Price Range (€/hr)',
    price_min_placeholder: 'Min',
    price_max_placeholder: 'Max',
    availability_label: 'Availability',
    avail_today: 'Today',
    avail_this_week: 'This week',
    avail_weekends: 'Weekends',
    experience_label: 'Experience Level',
    exp_junior: 'Junior (1-3 yrs)',
    exp_senior: 'Senior (4-7 yrs)',
    exp_expert: 'Expert (8+ yrs)',
    specialization_label: 'Specialization',
    rating_label: 'Rating',
    rating_4: '4★ & above',
    rating_45: '4.5★ & above',
    rating_5: '5★ only',
    apply_filters_btn: 'Apply Filters',
    providers_found_suffix: 'providers found',
    sort_by_label: 'Sort by:',
    sort_relevant: 'Most Relevant',
    sort_rating_opt: 'Top Rated',
    sort_price: 'Lowest Price',
    sort_reviews: 'Most Reviews',

    // SPECIALIZATIONS (arrays)
    spec_healthcare: ['Elderly Care', 'Post-Surgery', 'Dementia Care', 'ICU Support', 'Physiotherapy', 'Palliative Care'],
    spec_home_support: ['House Cleaning', 'Cooking', 'Childcare', 'Grocery Runs', 'Laundry', 'Pet Care'],
    spec_personal_support: ['Counseling', 'Life Coaching', 'Companionship', 'Grief Support', 'Family Therapy'],

    // SERVICE LISTING PAGE
    breadcrumb_healthcare: 'Healthcare Support',
    sl_experience: 'experience',
    sl_reviews: 'reviews',
    sl_repeat_hire: '% repeat hire rate',
    sl_about_me: 'About me',
    sl_whats_included: "What's included",
    sl_credentials: 'Credentials & Certifications',
    sl_reviews_title: 'Reviews',
    sl_all_ratings: 'All ratings',
    sl_5_stars: '5 stars',
    sl_4_stars: '4 stars',
    sl_3_stars: '3 stars',
    sl_stars: 'stars',
    sl_load_more: 'Load more reviews',
    sl_book_session: 'Book a session',
    sl_book_sub: 'Select a package and schedule your care',
    sl_of_care: 'of care',
    sl_select_date: 'Select date',
    sl_book_now: 'Book Now',
    sl_message_provider: 'Message Provider',
    sl_safe_payment: 'Safe & secure payment',
    sl_verified_provider: 'Verified provider',
    sl_free_cancel: 'Free cancellation (24hr notice)',

    // BOOKING FLOW PAGE
    book_breadcrumb: 'Book',
    book_step1: 'Service Details',
    book_step2: 'Schedule',
    book_step3: 'Confirm & Pay',
    book_confirm_service: 'Confirm Your Service',
    book_of_care_included: 'of care included',
    book_notes_label: 'Special requirements or notes (optional)',
    book_notes_placeholder: 'Let the caregiver know about any special needs, medical conditions, or specific requirements...',
    book_continue_schedule: 'Continue to Schedule',
    book_choose_datetime: 'Choose Date & Time',
    book_select_date: 'Select Date',
    book_select_time: 'Select Start Time',
    book_booking_type: 'Booking Type',
    book_one_time: 'One-time',
    book_weekly: 'Weekly',
    book_monthly: 'Monthly',
    book_service_address: 'Service Address',
    book_full_address: 'Full address',
    book_city: 'City',
    book_pincode: 'Pincode',
    book_back: 'Back',
    book_continue_payment: 'Continue to Payment',
    book_order_summary: 'Order Summary',
    book_service: 'Service',
    book_provider: 'Provider',
    book_date_time: 'Date & Time',
    book_duration: 'Duration',
    book_service_fee: 'Service Fee',
    book_platform_fee: 'Platform Fee',
    book_total: 'Total',
    book_promo_placeholder: 'Promo code',
    book_apply: 'Apply',
    book_payment_method: 'Payment Method',
    book_safe_payment: 'Safe payment',
    book_verified_provider: 'Verified provider',
    book_free_cancel: 'Free cancellation (24hr)',
    book_not_selected: 'Not selected',
    book_confirm_btn: 'Confirm Booking',
    book_confirm_heading: 'Booking Confirmed!',
    book_confirm_body: 'has been confirmed. You will receive a confirmation email shortly with all the details.',
    book_confirm_summary: 'Booking Summary',
    book_confirm_tbc: 'To be confirmed',
    book_back_home: 'Back to Home',
    book_browse_providers: 'Browse More Providers',

    // PROVIDER PROFILE PAGE
    pp_member_since: 'Member since',
    pp_tab_overview: 'Overview',
    pp_tab_services: 'Services',
    pp_tab_reviews: 'Reviews',
    pp_tab_credentials: 'Credentials',
    pp_book_now: 'Book Now',
    pp_book_session: 'Book a Session',
    pp_message: 'Message',
    pp_verified: 'Verified',
    pp_top_rated: 'Top Rated',
    pp_stat_bookings: 'Total Bookings',
    pp_stat_experience: 'Experience',
    pp_stat_response: 'Response Time',
    pp_stat_reviews: 'reviews',
    pp_about: 'About',
    pp_areas_served: 'Areas Served',
    pp_languages: 'Languages',
    pp_view_details: 'View Details',
    pp_load_more: 'Load more reviews',
    pp_identity_verified: 'Identity Verified',
    pp_identity_sub: 'Government ID verified by Lotus Care',
    pp_background_check: 'Background Check',
    pp_background_sub: 'Completed on March 2024',
    pp_starting_from: 'Starting from',
    pp_usually_responds: 'Usually responds',
    pp_verified_checked: 'Verified & background checked',

    // ABOUT PAGE
    about_title: 'About Us',
    about_intro: 'Lotus Care is a dedicated platform connecting families with compassionate, verified caregivers across India and Europe.',
    about_mission: 'Our mission is to provide accessible, trustworthy home care services that empower both families and care professionals.',
    about_value_care: 'Compassionate Care',
    about_value_care_desc: 'We prioritize human connection and genuine care in every interaction.',
    about_value_trust: 'Trust & Safety',
    about_value_trust_desc: 'Every caregiver is verified and background-checked for your peace of mind.',
    about_value_access: 'Accessibility',
    about_value_access_desc: 'Quality care services available across multiple regions and languages.',
    about_story_title: 'Our Story',
    about_story: 'Founded with the vision of transforming home care services, Lotus Care brings together families seeking quality care and dedicated professionals passionate about making a difference.',
    about_cta: 'Find a Caregiver',

    // CONTACT PAGE
    contact_title: 'Contact Us',
    contact_subtitle: 'Have a question? We\'d love to hear from you. Get in touch with our team.',
    contact_email_label: 'Email',
    contact_phone_label: 'Phone',
    contact_location_label: 'Location',
    contact_form_title: 'Send us a Message',
    contact_name_label: 'Full Name',
    contact_name_placeholder: 'Your name',
    contact_email_placeholder: 'your@email.com',
    contact_message_label: 'Message',
    contact_message_placeholder: 'Tell us how we can help...',
    contact_submit: 'Send Message',
    contact_success: 'Thank you for reaching out. We will respond soon.',

    // CAREERS PAGE
    careers_title: 'Join Our Team',
    careers_intro: 'We\'re building the future of home care. Join us in our mission to connect families with compassionate, verified caregivers.',
    careers_open_positions: 'Open Positions',
    careers_apply: 'Apply',
    career_title_1: 'Senior Full-Stack Engineer',
    career_location_1: 'India / Europe',
    career_title_2: 'Care Operations Manager',
    career_location_2: 'India',
    career_title_3: 'Community Support Specialist',
    career_location_3: 'Remote',
    career_title_4: 'Marketing Coordinator',
    career_location_4: 'Europe',
    career_type_full: 'Full-time',
    career_type_contract: 'Contract',
    careers_benefits_title: 'Why Join Lotus Care?',
    careers_benefit_1: 'Competitive Benefits',
    careers_benefit_1_desc: 'Health insurance, paid leave, and professional development opportunities.',
    careers_benefit_2: 'Flexible Work',
    careers_benefit_2_desc: 'Remote-friendly roles with flexible schedules that fit your lifestyle.',
    careers_benefit_3: 'Mission-Driven',
    careers_benefit_3_desc: 'Work on projects that directly impact families and care professionals.',
    careers_benefit_4: 'Growth Opportunities',
    careers_benefit_4_desc: 'Learn, grow, and advance your career with a supportive team.',
    careers_cta: 'Didn\'t find what you\'re looking for?',
    careers_contact_us: 'Contact Us',

    // HELP PAGE
    help_title: 'Help Center',
    help_subtitle: 'Find answers to common questions and get support when you need it.',
    help_search_placeholder: 'Search for help...',
    help_faq_1_q: 'How do I find a caregiver?',
    help_faq_1_a: 'Browse our categories, view caregiver profiles, check ratings and reviews, and book directly through our platform.',
    help_faq_2_q: 'Are caregivers verified?',
    help_faq_2_a: 'Yes, all caregivers undergo background checks and verification before joining our platform. Your safety is our priority.',
    help_faq_3_q: 'What payment methods do you accept?',
    help_faq_3_a: 'We accept credit/debit cards, digital wallets, and bank transfers for secure payments.',
    help_faq_4_q: 'Can I cancel a booking?',
    help_faq_4_a: 'Yes, cancellations can be made up to 24 hours before the scheduled service for a full refund.',
    help_faq_5_q: 'How is pricing determined?',
    help_faq_5_a: 'Pricing varies by service type, caregiver experience, location, and demand. Each profile displays hourly or service rates clearly.',
    help_faq_6_q: 'Do you offer 24/7 support?',
    help_faq_6_a: 'Yes, our customer support team is available around the clock to assist with any questions or concerns.',
    help_no_results: 'No results found. Please try another search.',
    help_still_need_help: 'Still need help?',
    help_contact_support: 'Our support team is here to assist you.',
    help_contact_us: 'Contact Support',

    // SAFETY PAGE
    safety_title: 'Safety Center',
    safety_intro: 'Your safety is our top priority. We are committed to maintaining a secure platform for both families and care professionals.',
    safety_verification_title: 'Caregiver Verification Process',
    safety_verify_1: 'Identity Verification',
    safety_verify_1_desc: 'Government-issued ID verification and address confirmation.',
    safety_verify_2: 'Background Check',
    safety_verify_2_desc: 'Comprehensive criminal background screening.',
    safety_verify_3: 'Reference Check',
    safety_verify_3_desc: 'Verification of professional references and work history.',
    safety_verify_4: 'Skill Certification',
    safety_verify_4_desc: 'Verification of certifications and relevant qualifications.',
    safety_tips_title: 'Safety Tips for Families',
    safety_tip_1: 'Always conduct a video call before confirming a booking.',
    safety_tip_2: 'Share caregiver details with trusted family members.',
    safety_tip_3: 'Start with shorter service periods to build trust.',
    safety_tip_4: 'Maintain clear communication channels for real-time updates.',
    safety_tip_5: 'Report any concerns immediately to our support team.',
    safety_data_title: 'Data Security & Privacy',
    safety_data_desc: 'We use industry-standard encryption to protect your personal information. All data is stored securely and never shared with third parties without your consent.',
    safety_concern: 'Have a safety concern?',
    safety_report: 'Report an Issue',

    // GUIDELINES PAGE
    guidelines_title: 'Community Guidelines',
    guidelines_intro: 'These guidelines help us maintain a safe, respectful, and trustworthy community for everyone. All members must adhere to these standards.',
    guidelines_respect_title: 'Respect & Professionalism',
    guidelines_respect_content: 'All community members must treat each other with respect and professionalism. Harassment, discrimination, or abusive behavior is strictly prohibited.',
    guidelines_honest_title: 'Honesty & Integrity',
    guidelines_honest_content: 'Be truthful in your profile information, ratings, and reviews. Fraudulent activity or misrepresentation is grounds for immediate account suspension.',
    guidelines_confidential_title: 'Confidentiality',
    guidelines_confidential_content: 'Caregivers must respect the privacy of families. All personal information shared during care is strictly confidential.',
    guidelines_quality_title: 'Quality Service',
    guidelines_quality_content: 'Caregivers must provide services as promised. Cancellations should be made with advance notice when possible.',
    guidelines_safety_title: 'Safety First',
    guidelines_safety_content: 'Never engage in illegal activities or activities that compromise safety. Report suspicious behavior immediately.',
    guidelines_communication_title: 'Clear Communication',
    guidelines_communication_content: 'Maintain open and transparent communication. Address concerns promptly through our platform.',
    guidelines_violations_title: 'Violations & Enforcement',
    guidelines_violations_content: 'Violations of these guidelines may result in warnings, account suspension, or permanent removal from the platform.',
    guidelines_report_content: 'If you witness a violation, please report it immediately to our support team.',
    guidelines_contact: 'Report a Violation',

    // BLOG PAGE
    blog_title: 'Blog',
    blog_subtitle: 'Insights, tips, and stories from the Lotus Care community.',
    blog_post_1_title: 'Tips for Finding the Right Caregiver',
    blog_post_1_excerpt: 'Learn how to identify and select the perfect caregiver for your family needs.',
    blog_post_2_title: 'Understanding Home Care Options',
    blog_post_2_excerpt: 'A comprehensive guide to different types of home care services available on our platform.',
    blog_post_3_title: 'Building Trust in Caregiving Relationships',
    blog_post_3_excerpt: 'Expert advice on how families can establish strong, trustworthy relationships with caregivers.',
    blog_post_4_title: 'Health & Wellness Tips for Seniors',
    blog_post_4_excerpt: 'Essential health practices and wellness tips for maintaining quality of life in your senior years.',
    blog_author: 'Lotus Care Team',
    blog_read_more: 'Read More →',
    blog_subscribe: 'Subscribe to our newsletter for updates.',
    blog_email_placeholder: 'your@email.com',
    blog_subscribe_btn: 'Subscribe',

    // PRESS PAGE
    press_title: 'Press',
    press_subtitle: 'Latest news and updates from Lotus Care.',
    press_release_1_title: 'Lotus Care Launches Home Service Marketplace in Europe',
    press_release_1_excerpt: 'Expanding our commitment to accessible home care services across Europe.',
    press_release_2_title: 'Lotus Care Reaches 10,000 Active Caregivers',
    press_release_2_excerpt: 'Celebrating a milestone as we continue to grow our network of verified caregivers.',
    press_release_3_title: 'New Safety Features Announced',
    press_release_3_excerpt: 'Enhanced verification and real-time safety features for families and caregivers.',
    press_resources_title: 'Press Resources',
    press_resource_1: 'Brand Assets',
    press_resource_1_desc: 'Download logos and brand guidelines',
    press_resource_2: 'Media Kit',
    press_resource_2_desc: 'Complete information about Lotus Care',
    press_contact_title: 'Press Inquiries',
    press_contact_desc: 'Have a media inquiry? Get in touch with our press team.',
    press_email: 'press@lotuscare.com',

    // PARTNERS PAGE
    partners_title: 'Our Partners',
    partners_intro: 'We collaborate with leading organizations to provide the best home care services. Our partners share our commitment to trust, safety, and quality.',
    partner_1: 'Healthcare Network India',
    partner_2: 'EuroCare Services',
    partner_3: 'Trust Verification Labs',
    partner_4: 'Digital Pay Solutions',
    partner_type_healthcare: 'Healthcare Partner',
    partner_type_care: 'Care Partner',
    partner_type_verification: 'Verification Partner',
    partner_type_payment: 'Payment Partner',
    partners_opportunities_title: 'Partnership Opportunities',
    partners_opportunities_desc: 'We are always looking to collaborate with organizations that share our mission of providing accessible, trustworthy home care services.',
    partners_opportunities_contact: 'If you are interested in partnering with Lotus Care, we would love to hear from you.',
    partners_contact_us: 'Become a Partner',

    // ACCESSIBILITY PAGE
    accessibility_title: 'Accessibility',
    accessibility_intro: 'We are committed to making Lotus Care accessible to everyone, including people with disabilities.',
    accessibility_feature_1: 'Vision Support',
    accessibility_feature_1_desc: 'Full screen reader support, high contrast mode, and adjustable text sizes to accommodate users with vision impairments.',
    accessibility_feature_2: 'Keyboard Navigation',
    accessibility_feature_2_desc: 'Complete keyboard navigation support allowing users to navigate without a mouse.',
    accessibility_feature_3: 'Multi-Language Support',
    accessibility_feature_3_desc: 'Available in multiple languages to serve diverse communities.',
    accessibility_standards_title: 'Accessibility Standards',
    accessibility_standards_content: 'We aim to comply with WCAG 2.1 Level AA accessibility standards and continue to improve our platform to ensure it\'s usable by everyone.',
    accessibility_feedback: 'We welcome feedback on accessibility issues. If you encounter any barriers while using Lotus Care, please let us know.',
    accessibility_need_help: 'Need accessibility assistance?',
    accessibility_contact_us: 'Contact Support',
  },

  // ─────────────────────────────────────────
  //  HINDI
  // ─────────────────────────────────────────
  hi: {
    // NAVBAR
    nav_healthcare: 'स्वास्थ्य सेवा',
    nav_home_support: 'गृह सहायता',
    nav_personal_support: 'व्यक्तिगत सहायता',
    nav_how_it_works: 'यह कैसे काम करता है',
    nav_for_providers: 'प्रदाताओं के लिए',
    nav_find_caregiver: 'देखभालकर्ता खोजें',
    nav_sign_in: 'साइन इन',
    download_android: 'Android के लिए डाउनलोड करें',
    download_ios: 'iOS के लिए डाउनलोड करें',

    // HERO
    hero_badge: 'भारत और यूरोप में 40,000+ परिवारों का भरोसा',
    hero_headline: 'देखभाल जो लगे जैसे',
    hero_headline_em: 'परिवार',
    hero_sub: 'सत्यापित नर्स, देखभालकर्ता, गृह सहायक और परामर्शदाता खोजें — चुने हुए, बैकग्राउंड-चेक किए गए और जब आपको सबसे अधिक जरूरत हो, मदद के लिए तैयार।',
    hero_search_placeholder: 'आप किस तरह की देखभाल ढूंढ रहे हैं?',
    hero_search_btn: 'खोजें',
    hero_trust_verified: 'बैकग्राउंड सत्यापित',
    hero_trust_insured: 'बीमाकृत',
    hero_trust_rating: 'औसत 4.9 रेटिंग',

    // HERO FLOATING CARDS
    hero_card_badge: '✓ सत्यापित नर्स',
    hero_card_specialty: 'सर्जरी के बाद देखभाल • 8 वर्ष अनुभव',
    hero_booking_status: 'बुकिंग की पुष्टि हुई',
    hero_booking_service: 'सर्जरी के बाद देखभाल',
    hero_booking_time: 'कल, सुबह 9:00 - शाम 5:00',
    hero_booking_action: 'देखभालकर्ता रास्ते में है',
    hero_matched_label: 'आपके लिए मिलान',
    hero_matched_distance: '2.5 किमी दूर',

    // QUICK FILTERS
    quickFilters: ['बुजुर्ग देखभाल', 'सर्जरी के बाद नर्स', 'घर की सफाई', 'परामर्श', 'बाल देखभाल', 'साथी'],

    // CATEGORIES SECTION
    cat_overline: 'हमारी सेवाएं',
    cat_heading: 'हर तरह की देखभाल, एक छत के नीचे',
    cat_sub: 'चिकित्सा सहायता से लेकर रोजमर्रा की मदद तक — वो देखभाल चुनें जो आपकी जिंदगी में फिट हो।',
    cat_providers_label: 'प्रदाता',
    cat_explore: 'देखें',

    cat1_title: 'स्वास्थ्य सहायता',
    cat1_desc: 'घर पर पेशेवर चिकित्सा देखभाल — नर्सिंग से लेकर पुनर्वास तक।',
    cat1_tags: ['बुजुर्ग देखभाल', 'सर्जरी के बाद', 'डिमेंशिया देखभाल', 'आईसीयू सहायता'],

    cat2_title: 'गृह सहायता',
    cat2_desc: 'रोजमर्रा के घरेलू कामों और पारिवारिक जरूरतों के लिए विश्वसनीय मदद।',
    cat2_tags: ['सफाई', 'खाना बनाना', 'किराना', 'बच्चों की देखभाल'],

    cat3_title: 'व्यक्तिगत सहायता',
    cat3_desc: 'भावनात्मक स्वास्थ्य, साथ और जब चाहिए मार्गदर्शन।',
    cat3_tags: ['परामर्श', 'जीवन कोचिंग', 'संगति', 'दुख सहायता'],

    // FEATURED PROVIDERS
    featured_overline: 'विशेष प्रदाता',
    featured_heading: 'आप जैसे परिवारों का भरोसा',
    featured_view_all: 'सभी प्रदाता देखें',
    badge_verified: '✓ सत्यापित',

    // STATS
    stat_families: 'परिवारों की सेवा',
    stat_rating: 'औसत प्रदाता रेटिंग',
    stat_caregivers: 'सत्यापित देखभालकर्ता',
    stat_satisfaction: 'संतुष्टि दर',

    // HOW IT WORKS
    how_heading: '4 आसान चरणों में देखभाल',
    how_step1_title: 'अपनी जरूरतें बताएं',
    how_step1_desc: 'हमें बताएं कि आप किस तरह की देखभाल चाहते हैं और कोई विशेष आवश्यकताएं।',
    how_step2_title: 'मिलान किए गए प्रदाता देखें',
    how_step2_desc: 'सत्यापित प्रोफाइल, रेटिंग और समीक्षाएं देखें।',
    how_step3_title: 'जुड़ें और पुष्टि करें',
    how_step3_desc: 'प्रदाताओं से संपर्क करें, विवरण पर चर्चा करें और विश्वास के साथ बुक करें।',
    how_step4_title: 'निरंतर सहायता',
    how_step4_desc: 'हमारी संतुष्टि गारंटी और 24/7 सहायता के साथ गुणवत्तापूर्ण देखभाल प्राप्त करें।',

    // TESTIMONIALS
    test_overline: 'परिवार क्या कहते हैं',
    test_heading: 'विश्वास और देखभाल की कहानियां',

    // RECRUITMENT BANNER
    recruit_heading: 'क्या आप एक देखभालकर्ता, नर्स या परामर्शदाता हैं?',
    recruit_body: 'भारत के सबसे तेजी से बढ़ते केयर मार्केटप्लेस से जुड़ें। अपना खुद का शेड्यूल सेट करें और अपने अभ्यास को बढ़ाएं।',
    perk_free: 'शामिल होना मुफ्त',
    perk_payouts: 'तत्काल भुगतान',
    perk_schedule: 'आप अपना शेड्यूल तय करें',
    perk_insurance: 'देयता बीमा शामिल',
    btn_become_provider: 'प्रदाता बनें',
    btn_learn_more: 'और जानें',

    // FINAL CTA
    cta_heading: 'आपके परिवार को सबसे अच्छी देखभाल मिलनी चाहिए',
    cta_body: 'चाहे आपको चिकित्सा सहायता हो, घर में मदद हो, या किसी से बात करनी हो — हम आपको विश्वसनीय देखभालकर्ताओं से जोड़ने के लिए यहां हैं।',
    btn_find_today: 'आज देखभालकर्ता खोजें',
    btn_browse_services: 'सभी सेवाएं देखें',

    // FOOTER
    footer_tagline: 'भारत और यूरोप में परिवारों को सत्यापित, दयालु देखभालकर्ताओं से जोड़ना। विश्वास, सुरक्षा और मानवीय संबंध — यही हमारा वादा है।',
    footer_col_services: 'सेवाएं',
    footer_col_company: 'कंपनी',
    footer_col_support: 'सहायता',
    footer_copyright: '© 2025 Lotus Care. सर्वाधिकार सुरक्षित।',
    footer_healthcare: 'स्वास्थ्य सहायता',
    footer_home_support: 'गृह सहायता',
    footer_personal_support: 'व्यक्तिगत सहायता',
    footer_elderly: 'बुजुर्ग देखभाल',
    footer_post_surgery: 'सर्जरी के बाद देखभाल',
    footer_about: 'हमारे बारे में',
    footer_careers: 'करियर',
    footer_press: 'प्रेस',
    footer_blog: 'ब्लॉग',
    footer_partners: 'साझेदार',
    footer_help: 'सहायता केंद्र',
    footer_safety: 'सुरक्षा केंद्र',
    footer_guidelines: 'सामुदायिक दिशानिर्देश',
    footer_contact: 'संपर्क करें',
    footer_accessibility: 'पहुंच',

    // CATEGORY PAGE
    breadcrumb_home: 'होम',
    providers_available_suffix: '+ प्रदाता उपलब्ध',
    filters_title: 'फ़िल्टर',
    price_range_label: 'मूल्य सीमा (€/घंटा)',
    price_min_placeholder: 'न्यूनतम',
    price_max_placeholder: 'अधिकतम',
    availability_label: 'उपलब्धता',
    avail_today: 'आज',
    avail_this_week: 'इस सप्ताह',
    avail_weekends: 'सप्ताहांत',
    experience_label: 'अनुभव स्तर',
    exp_junior: 'जूनियर (1-3 वर्ष)',
    exp_senior: 'सीनियर (4-7 वर्ष)',
    exp_expert: 'विशेषज्ञ (8+ वर्ष)',
    specialization_label: 'विशेषज्ञता',
    rating_label: 'रेटिंग',
    rating_4: '4★ और ऊपर',
    rating_45: '4.5★ और ऊपर',
    rating_5: '5★ केवल',
    apply_filters_btn: 'फ़िल्टर लागू करें',
    providers_found_suffix: 'प्रदाता मिले',
    sort_by_label: 'क्रमबद्ध करें:',
    sort_relevant: 'सबसे प्रासंगिक',
    sort_rating_opt: 'शीर्ष रेटेड',
    sort_price: 'सबसे कम कीमत',
    sort_reviews: 'सबसे अधिक समीक्षाएं',

    // SPECIALIZATIONS
    spec_healthcare: ['बुजुर्ग देखभाल', 'सर्जरी के बाद', 'डिमेंशिया देखभाल', 'आईसीयू सहायता', 'फिजियोथेरेपी', 'उपशामक देखभाल'],
    spec_home_support: ['घर की सफाई', 'खाना पकाना', 'बाल देखभाल', 'किराना', 'धुलाई', 'पालतू देखभाल'],
    spec_personal_support: ['परामर्श', 'जीवन कोचिंग', 'संगति', 'दुख सहायता', 'पारिवारिक चिकित्सा'],

    // SERVICE LISTING PAGE
    breadcrumb_healthcare: 'स्वास्थ्य सहायता',
    sl_experience: 'अनुभव',
    sl_reviews: 'समीक्षाएं',
    sl_repeat_hire: '% पुनः नियुक्ति दर',
    sl_about_me: 'मेरे बारे में',
    sl_whats_included: 'क्या शामिल है',
    sl_credentials: 'योग्यता और प्रमाणपत्र',
    sl_reviews_title: 'समीक्षाएं',
    sl_all_ratings: 'सभी रेटिंग',
    sl_5_stars: '5 सितारे',
    sl_4_stars: '4 सितारे',
    sl_3_stars: '3 सितारे',
    sl_stars: 'सितारे',
    sl_load_more: 'और समीक्षाएं लोड करें',
    sl_book_session: 'सेशन बुक करें',
    sl_book_sub: 'एक पैकेज चुनें और अपनी देखभाल शेड्यूल करें',
    sl_of_care: 'देखभाल की',
    sl_select_date: 'तारीख चुनें',
    sl_book_now: 'अभी बुक करें',
    sl_message_provider: 'प्रदाता को संदेश करें',
    sl_safe_payment: 'सुरक्षित भुगतान',
    sl_verified_provider: 'सत्यापित प्रदाता',
    sl_free_cancel: 'मुफ्त रद्दीकरण (24 घंटे नोटिस)',

    // BOOKING FLOW PAGE
    book_breadcrumb: 'बुक करें',
    book_step1: 'सेवा विवरण',
    book_step2: 'शेड्यूल',
    book_step3: 'पुष्टि और भुगतान',
    book_confirm_service: 'अपनी सेवा की पुष्टि करें',
    book_of_care_included: 'देखभाल शामिल',
    book_notes_label: 'विशेष आवश्यकताएं या नोट्स (वैकल्पिक)',
    book_notes_placeholder: 'देखभालकर्ता को किसी विशेष जरूरत, चिकित्सा स्थिति या आवश्यकताओं के बारे में बताएं...',
    book_continue_schedule: 'शेड्यूल पर जारी रखें',
    book_choose_datetime: 'तारीख और समय चुनें',
    book_select_date: 'तारीख चुनें',
    book_select_time: 'प्रारंभ समय चुनें',
    book_booking_type: 'बुकिंग प्रकार',
    book_one_time: 'एक बार',
    book_weekly: 'साप्ताहिक',
    book_monthly: 'मासिक',
    book_service_address: 'सेवा का पता',
    book_full_address: 'पूरा पता',
    book_city: 'शहर',
    book_pincode: 'पिनकोड',
    book_back: 'वापस',
    book_continue_payment: 'भुगतान पर जारी रखें',
    book_order_summary: 'ऑर्डर सारांश',
    book_service: 'सेवा',
    book_provider: 'प्रदाता',
    book_date_time: 'तारीख और समय',
    book_duration: 'अवधि',
    book_service_fee: 'सेवा शुल्क',
    book_platform_fee: 'प्लेटफॉर्म शुल्क',
    book_total: 'कुल',
    book_promo_placeholder: 'प्रोमो कोड',
    book_apply: 'लागू करें',
    book_payment_method: 'भुगतान विधि',
    book_safe_payment: 'सुरक्षित भुगतान',
    book_verified_provider: 'सत्यापित प्रदाता',
    book_free_cancel: 'मुफ्त रद्दीकरण (24 घंटे)',
    book_not_selected: 'चयन नहीं किया',
    book_confirm_btn: 'बुकिंग की पुष्टि करें',
    book_confirm_heading: 'बुकिंग की पुष्टि हुई!',
    book_confirm_body: 'की बुकिंग की पुष्टि हो गई है। आपको जल्द ही एक पुष्टिकरण ईमेल मिलेगा।',
    book_confirm_summary: 'बुकिंग सारांश',
    book_confirm_tbc: 'पुष्टि होनी बाकी है',
    book_back_home: 'होम पर वापस',
    book_browse_providers: 'अधिक प्रदाता देखें',

    // PROVIDER PROFILE PAGE
    pp_member_since: 'सदस्य बने',
    pp_tab_overview: 'अवलोकन',
    pp_tab_services: 'सेवाएं',
    pp_tab_reviews: 'समीक्षाएं',
    pp_tab_credentials: 'योग्यताएं',
    pp_book_now: 'अभी बुक करें',
    pp_book_session: 'सेशन बुक करें',
    pp_message: 'संदेश',
    pp_verified: 'सत्यापित',
    pp_top_rated: 'शीर्ष रेटेड',
    pp_stat_bookings: 'कुल बुकिंग',
    pp_stat_experience: 'अनुभव',
    pp_stat_response: 'प्रतिक्रिया समय',
    pp_stat_reviews: 'समीक्षाएं',
    pp_about: 'परिचय',
    pp_areas_served: 'सेवा क्षेत्र',
    pp_languages: 'भाषाएं',
    pp_view_details: 'विवरण देखें',
    pp_load_more: 'और समीक्षाएं लोड करें',
    pp_identity_verified: 'पहचान सत्यापित',
    pp_identity_sub: 'लोटस केयर द्वारा सरकारी आईडी सत्यापित',
    pp_background_check: 'बैकग्राउंड चेक',
    pp_background_sub: 'मार्च 2024 में पूर्ण',
    pp_starting_from: 'शुरुआत',
    pp_usually_responds: 'आमतौर पर प्रतिक्रिया देते हैं',
    pp_verified_checked: 'सत्यापित और बैकग्राउंड चेक',
  },

  // ─────────────────────────────────────────
  //  GERMAN
  // ─────────────────────────────────────────
  de: {
    // NAVBAR
    nav_healthcare: 'Gesundheit',
    nav_home_support: 'Haushaltshilfe',
    nav_personal_support: 'Persönliche Hilfe',
    nav_how_it_works: 'So funktioniert es',
    nav_for_providers: 'Für Anbieter',
    nav_find_caregiver: 'Pflegeperson finden',
    nav_sign_in: 'Anmelden',
    download_android: 'Für Android herunterladen',
    download_ios: 'Für iOS herunterladen',

    // HERO
    hero_badge: 'Von 40.000+ Familien in Indien und Europa vertraut',
    hero_headline: 'Pflege, die sich anfühlt wie',
    hero_headline_em: 'Familie',
    hero_sub: 'Finden Sie geprüfte Krankenschwestern, Betreuer, Haushaltshilfen und Berater — handverlesen, überprüft und bereit zu helfen, wenn Sie es am meisten brauchen.',
    hero_search_placeholder: 'Welche Art von Pflege suchen Sie?',
    hero_search_btn: 'Suchen',
    hero_trust_verified: 'Hintergrund geprüft',
    hero_trust_insured: 'Versichert',
    hero_trust_rating: 'Ø 4,9 Bewertung',

    // HERO FLOATING CARDS
    hero_card_badge: '✓ Geprüfte Krankenschwester',
    hero_card_specialty: 'Postoperative Pflege • 8 J. Erfahrung',
    hero_booking_status: 'Buchung bestätigt',
    hero_booking_service: 'Postoperative Pflege',
    hero_booking_time: 'Morgen, 9:00–17:00 Uhr',
    hero_booking_action: 'Pflegeperson ist unterwegs',
    hero_matched_label: 'Für Sie gefunden',
    hero_matched_distance: '2,5 km entfernt',

    // QUICK FILTERS
    quickFilters: ['Seniorenpflege', 'Post-OP-Krankenschwester', 'Hausreinigung', 'Beratung', 'Kinderbetreuung', 'Begleitung'],

    // CATEGORIES SECTION
    cat_overline: 'Unsere Leistungen',
    cat_heading: 'Jede Art von Pflege — unter einem Dach',
    cat_sub: 'Von medizinischer Versorgung bis zur Alltagshilfe — wählen Sie die Pflege, die zu Ihrem Leben passt.',
    cat_providers_label: 'Anbieter',
    cat_explore: 'Entdecken',

    cat1_title: 'Gesundheitliche Unterstützung',
    cat1_desc: 'Professionelle medizinische Versorgung zu Hause — von der Krankenpflege bis zur Rehabilitation.',
    cat1_tags: ['Seniorenpflege', 'Post-OP', 'Demenzpflege', 'Intensivpflege'],

    cat2_title: 'Haushaltshilfe',
    cat2_desc: 'Verlässliche Hilfe bei täglichen Haushaltsaufgaben und Familienbedürfnissen.',
    cat2_tags: ['Reinigung', 'Kochen', 'Einkaufen', 'Kinderbetreuung'],

    cat3_title: 'Persönliche Unterstützung',
    cat3_desc: 'Emotionales Wohlbefinden, Gesellschaft und Begleitung, wenn Sie es brauchen.',
    cat3_tags: ['Beratung', 'Life-Coaching', 'Gesellschaft', 'Trauerbegleitung'],

    // FEATURED PROVIDERS
    featured_overline: 'Empfohlene Anbieter',
    featured_heading: 'Von Familien wie Ihrer vertraut',
    featured_view_all: 'Alle Anbieter anzeigen',
    badge_verified: '✓ Geprüft',

    // STATS
    stat_families: 'Betreute Familien',
    stat_rating: 'Durchschnittliche Bewertung',
    stat_caregivers: 'Geprüfte Pflegekräfte',
    stat_satisfaction: 'Zufriedenheitsrate',

    // HOW IT WORKS
    how_heading: 'Pflege in 4 einfachen Schritten',
    how_step1_title: 'Bedarf beschreiben',
    how_step1_desc: 'Teilen Sie uns mit, welche Pflege Sie suchen und welche besonderen Anforderungen Sie haben.',
    how_step2_title: 'Passende Anbieter durchsuchen',
    how_step2_desc: 'Überprüfte Profile, Bewertungen und Rezensionen von Pflegekräften ansehen.',
    how_step3_title: 'Kontakt aufnehmen',
    how_step3_desc: 'Nachrichten senden, Details besprechen und sicher buchen.',
    how_step4_title: 'Laufende Unterstützung',
    how_step4_desc: 'Qualitätspflege mit unserer Zufriedenheitsgarantie und 24/7-Support.',

    // TESTIMONIALS
    test_overline: 'Was Familien sagen',
    test_heading: 'Geschichten von Vertrauen und Fürsorge',

    // RECRUITMENT BANNER
    recruit_heading: 'Sind Sie Pflegeperson, Krankenschwester oder Berater?',
    recruit_body: 'Treten Sie dem am schnellsten wachsenden Pflegemarktplatz bei. Legen Sie Ihren eigenen Zeitplan fest und bauen Sie Ihre Praxis aus.',
    perk_free: 'Kostenlose Anmeldung',
    perk_payouts: 'Sofortige Auszahlungen',
    perk_schedule: 'Sie bestimmen Ihren Zeitplan',
    perk_insurance: 'Haftpflichtversicherung inklusive',
    btn_become_provider: 'Anbieter werden',
    btn_learn_more: 'Mehr erfahren',

    // FINAL CTA
    cta_heading: 'Ihre Familie verdient die beste Pflege',
    cta_body: 'Ob medizinische Unterstützung, Haushaltshilfe oder jemand zum Reden — wir verbinden Sie mit vertrauenswürdigen, geprüften Pflegekräften.',
    btn_find_today: 'Heute Pflegeperson finden',
    btn_browse_services: 'Alle Leistungen durchsuchen',

    // FOOTER
    footer_tagline: 'Familien mit geprüften, einfühlsamen Pflegekräften in Indien und Europa verbinden. Vertrauen, Sicherheit und menschliche Verbindung — das ist unser Versprechen.',
    footer_col_services: 'Leistungen',
    footer_col_company: 'Unternehmen',
    footer_col_support: 'Support',
    footer_copyright: '© 2025 Lotus Care. Alle Rechte vorbehalten.',
    footer_healthcare: 'Gesundheitliche Unterstützung',
    footer_home_support: 'Haushaltshilfe',
    footer_personal_support: 'Persönliche Unterstützung',
    footer_elderly: 'Seniorenpflege',
    footer_post_surgery: 'Postoperative Pflege',
    footer_about: 'Über uns',
    footer_careers: 'Karriere',
    footer_press: 'Presse',
    footer_blog: 'Blog',
    footer_partners: 'Partner',
    footer_help: 'Hilfezentrum',
    footer_safety: 'Sicherheitszentrum',
    footer_guidelines: 'Community-Richtlinien',
    footer_contact: 'Kontakt',
    footer_accessibility: 'Barrierefreiheit',

    // CATEGORY PAGE
    breadcrumb_home: 'Startseite',
    providers_available_suffix: '+ Anbieter verfügbar',
    filters_title: 'Filter',
    price_range_label: 'Preisbereich (€/Std.)',
    price_min_placeholder: 'Min',
    price_max_placeholder: 'Max',
    availability_label: 'Verfügbarkeit',
    avail_today: 'Heute',
    avail_this_week: 'Diese Woche',
    avail_weekends: 'Wochenende',
    experience_label: 'Erfahrungsniveau',
    exp_junior: 'Junior (1–3 J.)',
    exp_senior: 'Senior (4–7 J.)',
    exp_expert: 'Experte (8+ J.)',
    specialization_label: 'Spezialisierung',
    rating_label: 'Bewertung',
    rating_4: '4★ und mehr',
    rating_45: '4,5★ und mehr',
    rating_5: 'Nur 5★',
    apply_filters_btn: 'Filter anwenden',
    providers_found_suffix: 'Anbieter gefunden',
    sort_by_label: 'Sortieren:',
    sort_relevant: 'Relevanteste',
    sort_rating_opt: 'Bestbewertet',
    sort_price: 'Günstigster Preis',
    sort_reviews: 'Meiste Bewertungen',

    // SPECIALIZATIONS
    spec_healthcare: ['Seniorenpflege', 'Post-OP', 'Demenzpflege', 'Intensivpflege', 'Physiotherapie', 'Palliativpflege'],
    spec_home_support: ['Hausreinigung', 'Kochen', 'Kinderbetreuung', 'Einkaufen', 'Wäsche', 'Tierbetreuung'],
    spec_personal_support: ['Beratung', 'Life-Coaching', 'Gesellschaft', 'Trauerbegleitung', 'Familientherapie'],

    // SERVICE LISTING PAGE
    breadcrumb_healthcare: 'Gesundheitliche Unterstützung',
    sl_experience: 'Erfahrung',
    sl_reviews: 'Bewertungen',
    sl_repeat_hire: '% Wiederbuchungsrate',
    sl_about_me: 'Über mich',
    sl_whats_included: 'Was enthalten ist',
    sl_credentials: 'Qualifikationen & Zertifikate',
    sl_reviews_title: 'Bewertungen',
    sl_all_ratings: 'Alle Bewertungen',
    sl_5_stars: '5 Sterne',
    sl_4_stars: '4 Sterne',
    sl_3_stars: '3 Sterne',
    sl_stars: 'Sterne',
    sl_load_more: 'Weitere Bewertungen laden',
    sl_book_session: 'Sitzung buchen',
    sl_book_sub: 'Paket auswählen und Pflege planen',
    sl_of_care: 'Pflege',
    sl_select_date: 'Datum wählen',
    sl_book_now: 'Jetzt buchen',
    sl_message_provider: 'Anbieter kontaktieren',
    sl_safe_payment: 'Sichere Zahlung',
    sl_verified_provider: 'Geprüfter Anbieter',
    sl_free_cancel: 'Kostenlose Stornierung (24 Std.)',

    // BOOKING FLOW PAGE
    book_breadcrumb: 'Buchen',
    book_step1: 'Servicedetails',
    book_step2: 'Zeitplan',
    book_step3: 'Bestätigen & Zahlen',
    book_confirm_service: 'Service bestätigen',
    book_of_care_included: 'Pflege enthalten',
    book_notes_label: 'Besondere Anforderungen oder Hinweise (optional)',
    book_notes_placeholder: 'Teilen Sie der Pflegeperson besondere Bedürfnisse oder medizinische Bedingungen mit...',
    book_continue_schedule: 'Weiter zur Planung',
    book_choose_datetime: 'Datum & Uhrzeit wählen',
    book_select_date: 'Datum wählen',
    book_select_time: 'Startzeit wählen',
    book_booking_type: 'Buchungsart',
    book_one_time: 'Einmalig',
    book_weekly: 'Wöchentlich',
    book_monthly: 'Monatlich',
    book_service_address: 'Serviceadresse',
    book_full_address: 'Vollständige Adresse',
    book_city: 'Stadt',
    book_pincode: 'Postleitzahl',
    book_back: 'Zurück',
    book_continue_payment: 'Weiter zur Zahlung',
    book_order_summary: 'Bestellübersicht',
    book_service: 'Service',
    book_provider: 'Anbieter',
    book_date_time: 'Datum & Uhrzeit',
    book_duration: 'Dauer',
    book_service_fee: 'Servicegebühr',
    book_platform_fee: 'Plattformgebühr',
    book_total: 'Gesamt',
    book_promo_placeholder: 'Gutscheincode',
    book_apply: 'Anwenden',
    book_payment_method: 'Zahlungsmethode',
    book_safe_payment: 'Sichere Zahlung',
    book_verified_provider: 'Geprüfter Anbieter',
    book_free_cancel: 'Kostenlose Stornierung (24 Std.)',
    book_not_selected: 'Nicht ausgewählt',
    book_confirm_btn: 'Buchung bestätigen',
    book_confirm_heading: 'Buchung bestätigt!',
    book_confirm_body: 'wurde bestätigt. Sie erhalten in Kürze eine Bestätigungs-E-Mail.',
    book_confirm_summary: 'Buchungsübersicht',
    book_confirm_tbc: 'Noch zu bestätigen',
    book_back_home: 'Zur Startseite',
    book_browse_providers: 'Weitere Anbieter',

    // PROVIDER PROFILE PAGE
    pp_member_since: 'Mitglied seit',
    pp_tab_overview: 'Übersicht',
    pp_tab_services: 'Leistungen',
    pp_tab_reviews: 'Bewertungen',
    pp_tab_credentials: 'Qualifikationen',
    pp_book_now: 'Jetzt buchen',
    pp_book_session: 'Sitzung buchen',
    pp_message: 'Nachricht',
    pp_verified: 'Geprüft',
    pp_top_rated: 'Bestbewertet',
    pp_stat_bookings: 'Buchungen gesamt',
    pp_stat_experience: 'Erfahrung',
    pp_stat_response: 'Reaktionszeit',
    pp_stat_reviews: 'Bewertungen',
    pp_about: 'Über mich',
    pp_areas_served: 'Einsatzgebiete',
    pp_languages: 'Sprachen',
    pp_view_details: 'Details anzeigen',
    pp_load_more: 'Weitere Bewertungen laden',
    pp_identity_verified: 'Identität geprüft',
    pp_identity_sub: 'Lichtbildausweis von Lotus Care geprüft',
    pp_background_check: 'Hintergrundprüfung',
    pp_background_sub: 'Abgeschlossen im März 2024',
    pp_starting_from: 'Ab',
    pp_usually_responds: 'Antwortet normalerweise',
    pp_verified_checked: 'Geprüft & Hintergrund gecheckt',
  },

  // ─────────────────────────────────────────
  //  SPANISH
  // ─────────────────────────────────────────
  es: {
    // NAVBAR
    nav_healthcare: 'Salud',
    nav_home_support: 'Apoyo en el hogar',
    nav_personal_support: 'Apoyo personal',
    nav_how_it_works: 'Cómo funciona',
    nav_for_providers: 'Para proveedores',
    nav_find_caregiver: 'Buscar cuidador',
    nav_sign_in: 'Iniciar sesión',
    download_android: 'Descargar para Android',
    download_ios: 'Descargar para iOS',

    // HERO
    hero_badge: 'De confianza para más de 40.000 familias en India y Europa',
    hero_headline: 'Cuidado que se siente como',
    hero_headline_em: 'familia',
    hero_sub: 'Encuentra enfermeras, cuidadores, ayudantes del hogar y consejeros verificados — seleccionados, con antecedentes comprobados y listos para ayudar cuando más lo necesitas.',
    hero_search_placeholder: '¿Qué tipo de cuidado buscas?',
    hero_search_btn: 'Buscar',
    hero_trust_verified: 'Antecedentes verificados',
    hero_trust_insured: 'Asegurado',
    hero_trust_rating: 'Promedio 4,9 estrellas',

    // HERO FLOATING CARDS
    hero_card_badge: '✓ Enfermera verificada',
    hero_card_specialty: 'Cuidado postoperatorio • 8 años exp.',
    hero_booking_status: 'Reserva confirmada',
    hero_booking_service: 'Cuidado postoperatorio',
    hero_booking_time: 'Mañana, 9:00 AM - 5:00 PM',
    hero_booking_action: 'Cuidador en camino',
    hero_matched_label: 'Encontrado para ti',
    hero_matched_distance: 'A 2,5 km',

    // QUICK FILTERS
    quickFilters: ['Cuidado de ancianos', 'Enfermera postoperatoria', 'Limpieza del hogar', 'Asesoramiento', 'Cuidado infantil', 'Compañía'],

    // CATEGORIES SECTION
    cat_overline: 'Nuestros servicios',
    cat_heading: 'Todo tipo de cuidado, bajo un mismo techo',
    cat_sub: 'Desde apoyo médico hasta ayuda diaria — elige el cuidado que se adapta a tu vida.',
    cat_providers_label: 'proveedores',
    cat_explore: 'Explorar',

    cat1_title: 'Apoyo sanitario',
    cat1_desc: 'Atención médica profesional en casa — desde enfermería hasta rehabilitación.',
    cat1_tags: ['Cuidado de mayores', 'Postoperatorio', 'Demencia', 'UCI'],

    cat2_title: 'Apoyo en el hogar',
    cat2_desc: 'Ayuda de confianza para las tareas diarias del hogar y las necesidades familiares.',
    cat2_tags: ['Limpieza', 'Cocina', 'Compras', 'Cuidado de niños'],

    cat3_title: 'Apoyo personal',
    cat3_desc: 'Bienestar emocional, compañía y orientación cuando lo necesitas.',
    cat3_tags: ['Asesoramiento', 'Coaching de vida', 'Compañía', 'Apoyo al duelo'],

    // FEATURED PROVIDERS
    featured_overline: 'Proveedores destacados',
    featured_heading: 'De confianza para familias como la tuya',
    featured_view_all: 'Ver todos los proveedores',
    badge_verified: '✓ Verificado',

    // STATS
    stat_families: 'Familias atendidas',
    stat_rating: 'Valoración media del proveedor',
    stat_caregivers: 'Cuidadores verificados',
    stat_satisfaction: 'Índice de satisfacción',

    // HOW IT WORKS
    how_heading: 'Cuidado en 4 sencillos pasos',
    how_step1_title: 'Describe tus necesidades',
    how_step1_desc: 'Cuéntanos qué tipo de cuidado buscas y cualquier requisito específico.',
    how_step2_title: 'Explora proveedores',
    how_step2_desc: 'Revisa perfiles verificados, valoraciones y reseñas de cuidadores.',
    how_step3_title: 'Conecta y confirma',
    how_step3_desc: 'Envía mensajes a proveedores, comenta los detalles y reserva con confianza.',
    how_step4_title: 'Apoyo continuo',
    how_step4_desc: 'Recibe atención de calidad con nuestra garantía de satisfacción y soporte 24/7.',

    // TESTIMONIALS
    test_overline: 'Lo que dicen las familias',
    test_heading: 'Historias de confianza y cuidado',

    // RECRUITMENT BANNER
    recruit_heading: '¿Eres cuidador, enfermero o consejero?',
    recruit_body: 'Únete al mercado de cuidados de más rápido crecimiento. Establece tu propio horario y haz crecer tu práctica.',
    perk_free: 'Registro gratuito',
    perk_payouts: 'Pagos instantáneos',
    perk_schedule: 'Tú decides tu horario',
    perk_insurance: 'Seguro de responsabilidad incluido',
    btn_become_provider: 'Conviértete en proveedor',
    btn_learn_more: 'Saber más',

    // FINAL CTA
    cta_heading: 'Tu familia merece el mejor cuidado',
    cta_body: 'Ya sea apoyo médico, ayuda en casa o alguien con quien hablar — estamos aquí para conectarte con cuidadores de confianza.',
    btn_find_today: 'Encuentra un cuidador hoy',
    btn_browse_services: 'Ver todos los servicios',

    // FOOTER
    footer_tagline: 'Conectando familias con cuidadores compasivos y verificados en India y Europa. Confianza, seguridad y conexión humana — esa es nuestra promesa.',
    footer_col_services: 'Servicios',
    footer_col_company: 'Empresa',
    footer_col_support: 'Soporte',
    footer_copyright: '© 2025 Lotus Care. Todos los derechos reservados.',
    footer_healthcare: 'Apoyo sanitario',
    footer_home_support: 'Apoyo en el hogar',
    footer_personal_support: 'Apoyo personal',
    footer_elderly: 'Cuidado de ancianos',
    footer_post_surgery: 'Cuidado postoperatorio',
    footer_about: 'Sobre nosotros',
    footer_careers: 'Empleo',
    footer_press: 'Prensa',
    footer_blog: 'Blog',
    footer_partners: 'Socios',
    footer_help: 'Centro de ayuda',
    footer_safety: 'Centro de seguridad',
    footer_guidelines: 'Normas de la comunidad',
    footer_contact: 'Contáctanos',
    footer_accessibility: 'Accesibilidad',

    // CATEGORY PAGE
    breadcrumb_home: 'Inicio',
    providers_available_suffix: '+ proveedores disponibles',
    filters_title: 'Filtros',
    price_range_label: 'Rango de precio (€/hr)',
    price_min_placeholder: 'Mín',
    price_max_placeholder: 'Máx',
    availability_label: 'Disponibilidad',
    avail_today: 'Hoy',
    avail_this_week: 'Esta semana',
    avail_weekends: 'Fines de semana',
    experience_label: 'Nivel de experiencia',
    exp_junior: 'Junior (1-3 años)',
    exp_senior: 'Senior (4-7 años)',
    exp_expert: 'Experto (8+ años)',
    specialization_label: 'Especialización',
    rating_label: 'Valoración',
    rating_4: '4★ y más',
    rating_45: '4,5★ y más',
    rating_5: 'Solo 5★',
    apply_filters_btn: 'Aplicar filtros',
    providers_found_suffix: 'proveedores encontrados',
    sort_by_label: 'Ordenar por:',
    sort_relevant: 'Más relevantes',
    sort_rating_opt: 'Mejor valorados',
    sort_price: 'Precio más bajo',
    sort_reviews: 'Más reseñas',

    // SPECIALIZATIONS
    spec_healthcare: ['Cuidado de mayores', 'Postoperatorio', 'Demencia', 'UCI', 'Fisioterapia', 'Cuidados paliativos'],
    spec_home_support: ['Limpieza del hogar', 'Cocina', 'Cuidado infantil', 'Compras', 'Lavandería', 'Cuidado de mascotas'],
    spec_personal_support: ['Asesoramiento', 'Coaching de vida', 'Compañía', 'Apoyo al duelo', 'Terapia familiar'],

    // SERVICE LISTING PAGE
    breadcrumb_healthcare: 'Apoyo sanitario',
    sl_experience: 'experiencia',
    sl_reviews: 'reseñas',
    sl_repeat_hire: '% tasa de recontratación',
    sl_about_me: 'Sobre mí',
    sl_whats_included: 'Qué incluye',
    sl_credentials: 'Credenciales y certificaciones',
    sl_reviews_title: 'Reseñas',
    sl_all_ratings: 'Todas las valoraciones',
    sl_5_stars: '5 estrellas',
    sl_4_stars: '4 estrellas',
    sl_3_stars: '3 estrellas',
    sl_stars: 'estrellas',
    sl_load_more: 'Cargar más reseñas',
    sl_book_session: 'Reservar sesión',
    sl_book_sub: 'Selecciona un paquete y programa tu cuidado',
    sl_of_care: 'de cuidado',
    sl_select_date: 'Seleccionar fecha',
    sl_book_now: 'Reservar ahora',
    sl_message_provider: 'Contactar proveedor',
    sl_safe_payment: 'Pago seguro',
    sl_verified_provider: 'Proveedor verificado',
    sl_free_cancel: 'Cancelación gratuita (24h)',

    // BOOKING FLOW PAGE
    book_breadcrumb: 'Reservar',
    book_step1: 'Detalles del servicio',
    book_step2: 'Horario',
    book_step3: 'Confirmar y pagar',
    book_confirm_service: 'Confirmar tu servicio',
    book_of_care_included: 'de cuidado incluido',
    book_notes_label: 'Requisitos especiales o notas (opcional)',
    book_notes_placeholder: 'Informa al cuidador sobre necesidades especiales, condiciones médicas o requisitos específicos...',
    book_continue_schedule: 'Continuar con el horario',
    book_choose_datetime: 'Elegir fecha y hora',
    book_select_date: 'Seleccionar fecha',
    book_select_time: 'Seleccionar hora de inicio',
    book_booking_type: 'Tipo de reserva',
    book_one_time: 'Una sola vez',
    book_weekly: 'Semanal',
    book_monthly: 'Mensual',
    book_service_address: 'Dirección del servicio',
    book_full_address: 'Dirección completa',
    book_city: 'Ciudad',
    book_pincode: 'Código postal',
    book_back: 'Atrás',
    book_continue_payment: 'Continuar con el pago',
    book_order_summary: 'Resumen del pedido',
    book_service: 'Servicio',
    book_provider: 'Proveedor',
    book_date_time: 'Fecha y hora',
    book_duration: 'Duración',
    book_service_fee: 'Tarifa del servicio',
    book_platform_fee: 'Tarifa de plataforma',
    book_total: 'Total',
    book_promo_placeholder: 'Código promocional',
    book_apply: 'Aplicar',
    book_payment_method: 'Método de pago',
    book_safe_payment: 'Pago seguro',
    book_verified_provider: 'Proveedor verificado',
    book_free_cancel: 'Cancelación gratuita (24h)',
    book_not_selected: 'No seleccionado',
    book_confirm_btn: 'Confirmar reserva',
    book_confirm_heading: '¡Reserva confirmada!',
    book_confirm_body: 'ha sido confirmada. Recibirás un correo de confirmación en breve.',
    book_confirm_summary: 'Resumen de reserva',
    book_confirm_tbc: 'Por confirmar',
    book_back_home: 'Volver al inicio',
    book_browse_providers: 'Ver más proveedores',

    // PROVIDER PROFILE PAGE
    pp_member_since: 'Miembro desde',
    pp_tab_overview: 'Resumen',
    pp_tab_services: 'Servicios',
    pp_tab_reviews: 'Reseñas',
    pp_tab_credentials: 'Credenciales',
    pp_book_now: 'Reservar ahora',
    pp_book_session: 'Reservar sesión',
    pp_message: 'Mensaje',
    pp_verified: 'Verificado',
    pp_top_rated: 'Mejor valorado',
    pp_stat_bookings: 'Reservas totales',
    pp_stat_experience: 'Experiencia',
    pp_stat_response: 'Tiempo de respuesta',
    pp_stat_reviews: 'reseñas',
    pp_about: 'Sobre mí',
    pp_areas_served: 'Zonas atendidas',
    pp_languages: 'Idiomas',
    pp_view_details: 'Ver detalles',
    pp_load_more: 'Cargar más reseñas',
    pp_identity_verified: 'Identidad verificada',
    pp_identity_sub: 'DNI verificado por Lotus Care',
    pp_background_check: 'Verificación de antecedentes',
    pp_background_sub: 'Completada en marzo de 2024',
    pp_starting_from: 'Desde',
    pp_usually_responds: 'Suele responder',
    pp_verified_checked: 'Verificado y con antecedentes comprobados',
  },

  // ─────────────────────────────────────────
  //  DUTCH
  // ─────────────────────────────────────────
  nl: {
    // NAVBAR
    nav_healthcare: 'Gezondheidszorg',
    nav_home_support: 'Thuishulp',
    nav_personal_support: 'Persoonlijke hulp',
    nav_how_it_works: 'Hoe het werkt',
    nav_for_providers: 'Voor zorgverleners',
    nav_find_caregiver: 'Vind een verzorger',
    nav_sign_in: 'Inloggen',
    download_android: 'Download voor Android',
    download_ios: 'Download voor iOS',

    // HERO
    hero_badge: 'Vertrouwd door 40.000+ gezinnen in India en Europa',
    hero_headline: 'Zorg die voelt als',
    hero_headline_em: 'familie',
    hero_sub: 'Vind geverifieerde verpleegkundigen, verzorgers, huishoudelijke hulpen en counselors — handgeselecteerd, gescreend en klaar om te helpen wanneer u het het meest nodig heeft.',
    hero_search_placeholder: 'Welk soort zorg zoekt u?',
    hero_search_btn: 'Zoeken',
    hero_trust_verified: 'Achtergrond geverifieerd',
    hero_trust_insured: 'Verzekerd',
    hero_trust_rating: 'Gem. 4,9 beoordeling',

    // HERO FLOATING CARDS
    hero_card_badge: '✓ Geverifieerde verpleegkundige',
    hero_card_specialty: 'Postoperatieve zorg • 8 jr ervaring',
    hero_booking_status: 'Boeking bevestigd',
    hero_booking_service: 'Postoperatieve zorg',
    hero_booking_time: 'Morgen, 9:00–17:00',
    hero_booking_action: 'Verzorger is onderweg',
    hero_matched_label: 'Voor u gevonden',
    hero_matched_distance: '2,5 km verwijderd',

    // QUICK FILTERS
    quickFilters: ['Ouderenzorg', 'Postoperatieve verpleegkundige', 'Huisreiniging', 'Counseling', 'Kinderopvang', 'Gezelschap'],

    // CATEGORIES SECTION
    cat_overline: 'Onze diensten',
    cat_heading: 'Elk soort zorg, onder één dak',
    cat_sub: 'Van medische ondersteuning tot dagelijkse hulp — kies de zorg die bij uw leven past.',
    cat_providers_label: 'zorgverleners',
    cat_explore: 'Ontdekken',

    cat1_title: 'Zorgondersteuning',
    cat1_desc: 'Professionele medische zorg thuis — van verpleging tot revalidatie.',
    cat1_tags: ['Ouderenzorg', 'Postoperatief', 'Dementiezorg', 'IC-ondersteuning'],

    cat2_title: 'Thuishulp',
    cat2_desc: 'Betrouwbare hulp bij dagelijkse huishoudelijke taken en gezinsbehoeften.',
    cat2_tags: ['Schoonmaken', 'Koken', 'Boodschappen', 'Kinderopvang'],

    cat3_title: 'Persoonlijke ondersteuning',
    cat3_desc: 'Emotioneel welzijn, gezelschap en begeleiding wanneer u het nodig heeft.',
    cat3_tags: ['Counseling', 'Levenscoaching', 'Gezelschap', 'Rouwbegeleiding'],

    // FEATURED PROVIDERS
    featured_overline: 'Uitgelichte zorgverleners',
    featured_heading: 'Vertrouwd door gezinnen zoals het uwe',
    featured_view_all: 'Alle zorgverleners bekijken',
    badge_verified: '✓ Geverifieerd',

    // STATS
    stat_families: 'Gezinnen geholpen',
    stat_rating: 'Gemiddelde beoordeling',
    stat_caregivers: 'Geverifieerde verzorgers',
    stat_satisfaction: 'Tevredenheidspercentage',

    // HOW IT WORKS
    how_heading: 'Zorg in 4 eenvoudige stappen',
    how_step1_title: 'Beschrijf uw behoeften',
    how_step1_desc: 'Vertel ons welke zorg u zoekt en eventuele specifieke vereisten.',
    how_step2_title: 'Bekijk passende zorgverleners',
    how_step2_desc: 'Bekijk geverifieerde profielen, beoordelingen en recensies.',
    how_step3_title: 'Maak contact en bevestig',
    how_step3_desc: 'Stuur berichten aan zorgverleners, bespreek details en boek met vertrouwen.',
    how_step4_title: 'Doorlopende ondersteuning',
    how_step4_desc: 'Ontvang kwaliteitszorg met onze tevredenheidsgarantie en 24/7 support.',

    // TESTIMONIALS
    test_overline: 'Wat gezinnen zeggen',
    test_heading: 'Verhalen van vertrouwen en zorg',

    // RECRUITMENT BANNER
    recruit_heading: 'Bent u een verzorger, verpleegkundige of counselor?',
    recruit_body: 'Sluit u aan bij de snelst groeiende zorgmarktplaats. Stel uw eigen schema in en laat uw praktijk groeien.',
    perk_free: 'Gratis aanmelden',
    perk_payouts: 'Directe uitbetalingen',
    perk_schedule: 'U bepaalt uw schema',
    perk_insurance: 'Aansprakelijkheidsverzekering inbegrepen',
    btn_become_provider: 'Zorgverlener worden',
    btn_learn_more: 'Meer informatie',

    // FINAL CTA
    cta_heading: 'Uw gezin verdient de allerbeste zorg',
    cta_body: 'Of u nu medische ondersteuning, hulp in huis of iemand om mee te praten nodig heeft — wij verbinden u met betrouwbare, geverifieerde verzorgers.',
    btn_find_today: 'Vind vandaag een verzorger',
    btn_browse_services: 'Alle diensten bekijken',

    // FOOTER
    footer_tagline: 'Gezinnen verbinden met geverifieerde, meelevende verzorgers in India en Europa. Vertrouwen, veiligheid en menselijk contact — dat is onze belofte.',
    footer_col_services: 'Diensten',
    footer_col_company: 'Bedrijf',
    footer_col_support: 'Ondersteuning',
    footer_copyright: '© 2025 Lotus Care. Alle rechten voorbehouden.',
    footer_healthcare: 'Zorgondersteuning',
    footer_home_support: 'Thuishulp',
    footer_personal_support: 'Persoonlijke ondersteuning',
    footer_elderly: 'Ouderenzorg',
    footer_post_surgery: 'Postoperatieve zorg',
    footer_about: 'Over ons',
    footer_careers: 'Vacatures',
    footer_press: 'Pers',
    footer_blog: 'Blog',
    footer_partners: 'Partners',
    footer_help: 'Helpcentrum',
    footer_safety: 'Veiligheidscentrum',
    footer_guidelines: 'Communityrichtlijnen',
    footer_contact: 'Contact',
    footer_accessibility: 'Toegankelijkheid',

    // CATEGORY PAGE
    breadcrumb_home: 'Home',
    providers_available_suffix: '+ zorgverleners beschikbaar',
    filters_title: 'Filters',
    price_range_label: 'Prijsbereik (€/uur)',
    price_min_placeholder: 'Min',
    price_max_placeholder: 'Max',
    availability_label: 'Beschikbaarheid',
    avail_today: 'Vandaag',
    avail_this_week: 'Deze week',
    avail_weekends: 'Weekenden',
    experience_label: 'Ervaringsniveau',
    exp_junior: 'Junior (1-3 jr)',
    exp_senior: 'Senior (4-7 jr)',
    exp_expert: 'Expert (8+ jr)',
    specialization_label: 'Specialisatie',
    rating_label: 'Beoordeling',
    rating_4: '4★ en hoger',
    rating_45: '4,5★ en hoger',
    rating_5: 'Alleen 5★',
    apply_filters_btn: 'Filters toepassen',
    providers_found_suffix: 'zorgverleners gevonden',
    sort_by_label: 'Sorteren op:',
    sort_relevant: 'Meest relevant',
    sort_rating_opt: 'Best beoordeeld',
    sort_price: 'Laagste prijs',
    sort_reviews: 'Meeste recensies',

    // SPECIALIZATIONS
    spec_healthcare: ['Ouderenzorg', 'Postoperatief', 'Dementiezorg', 'IC-ondersteuning', 'Fysiotherapie', 'Palliatieve zorg'],
    spec_home_support: ['Huisreiniging', 'Koken', 'Kinderopvang', 'Boodschappen', 'Was', 'Huisdierzorg'],
    spec_personal_support: ['Counseling', 'Levenscoaching', 'Gezelschap', 'Rouwbegeleiding', 'Gezinstherapie'],

    // SERVICE LISTING PAGE
    breadcrumb_healthcare: 'Zorgondersteuning',
    sl_experience: 'ervaring',
    sl_reviews: 'recensies',
    sl_repeat_hire: '% herboekingspercentage',
    sl_about_me: 'Over mij',
    sl_whats_included: 'Wat is inbegrepen',
    sl_credentials: 'Kwalificaties & certificaten',
    sl_reviews_title: 'Recensies',
    sl_all_ratings: 'Alle beoordelingen',
    sl_5_stars: '5 sterren',
    sl_4_stars: '4 sterren',
    sl_3_stars: '3 sterren',
    sl_stars: 'sterren',
    sl_load_more: 'Meer recensies laden',
    sl_book_session: 'Sessie boeken',
    sl_book_sub: 'Selecteer een pakket en plan uw zorg',
    sl_of_care: 'zorg',
    sl_select_date: 'Datum selecteren',
    sl_book_now: 'Nu boeken',
    sl_message_provider: 'Zorgverlener berichten',
    sl_safe_payment: 'Veilige betaling',
    sl_verified_provider: 'Geverifieerde zorgverlener',
    sl_free_cancel: 'Gratis annulering (24u van tevoren)',

    // BOOKING FLOW PAGE
    book_breadcrumb: 'Boeken',
    book_step1: 'Servicedetails',
    book_step2: 'Planning',
    book_step3: 'Bevestigen & betalen',
    book_confirm_service: 'Uw service bevestigen',
    book_of_care_included: 'zorg inbegrepen',
    book_notes_label: 'Bijzondere vereisten of notities (optioneel)',
    book_notes_placeholder: 'Laat de verzorger weten over bijzondere behoeften, medische aandoeningen of specifieke vereisten...',
    book_continue_schedule: 'Doorgaan naar planning',
    book_choose_datetime: 'Datum en tijd kiezen',
    book_select_date: 'Datum selecteren',
    book_select_time: 'Begintijd selecteren',
    book_booking_type: 'Boekingstype',
    book_one_time: 'Eenmalig',
    book_weekly: 'Wekelijks',
    book_monthly: 'Maandelijks',
    book_service_address: 'Serviceadres',
    book_full_address: 'Volledig adres',
    book_city: 'Stad',
    book_pincode: 'Postcode',
    book_back: 'Terug',
    book_continue_payment: 'Doorgaan naar betaling',
    book_order_summary: 'Besteloverzicht',
    book_service: 'Service',
    book_provider: 'Zorgverlener',
    book_date_time: 'Datum en tijd',
    book_duration: 'Duur',
    book_service_fee: 'Servicekosten',
    book_platform_fee: 'Platformkosten',
    book_total: 'Totaal',
    book_promo_placeholder: 'Promocode',
    book_apply: 'Toepassen',
    book_payment_method: 'Betaalmethode',
    book_safe_payment: 'Veilige betaling',
    book_verified_provider: 'Geverifieerde zorgverlener',
    book_free_cancel: 'Gratis annulering (24u)',
    book_not_selected: 'Niet geselecteerd',
    book_confirm_btn: 'Boeking bevestigen',
    book_confirm_heading: 'Boeking bevestigd!',
    book_confirm_body: 'is bevestigd. U ontvangt binnenkort een bevestigingsmail.',
    book_confirm_summary: 'Boekingsoverzicht',
    book_confirm_tbc: 'Nog te bevestigen',
    book_back_home: 'Terug naar home',
    book_browse_providers: 'Meer zorgverleners',

    // PROVIDER PROFILE PAGE
    pp_member_since: 'Lid sinds',
    pp_tab_overview: 'Overzicht',
    pp_tab_services: 'Diensten',
    pp_tab_reviews: 'Recensies',
    pp_tab_credentials: 'Kwalificaties',
    pp_book_now: 'Nu boeken',
    pp_book_session: 'Sessie boeken',
    pp_message: 'Bericht',
    pp_verified: 'Geverifieerd',
    pp_top_rated: 'Best beoordeeld',
    pp_stat_bookings: 'Totaal boekingen',
    pp_stat_experience: 'Ervaring',
    pp_stat_response: 'Reactietijd',
    pp_stat_reviews: 'recensies',
    pp_about: 'Over mij',
    pp_areas_served: 'Werkgebied',
    pp_languages: 'Talen',
    pp_view_details: 'Details bekijken',
    pp_load_more: 'Meer recensies laden',
    pp_identity_verified: 'Identiteit geverifieerd',
    pp_identity_sub: 'Overheids-ID geverifieerd door Lotus Care',
    pp_background_check: 'Achtergrondcontrole',
    pp_background_sub: 'Voltooid in maart 2024',
    pp_starting_from: 'Vanaf',
    pp_usually_responds: 'Reageert meestal',
    pp_verified_checked: 'Geverifieerd en gescreend',
  },

  // ─────────────────────────────────────────
  //  FRENCH
  // ─────────────────────────────────────────
  fr: {
    // NAVBAR
    nav_healthcare: 'Santé',
    nav_home_support: 'Aide à domicile',
    nav_personal_support: 'Soutien personnel',
    nav_how_it_works: 'Comment ça marche',
    nav_for_providers: 'Pour les prestataires',
    nav_find_caregiver: 'Trouver un soignant',
    nav_sign_in: 'Se connecter',
    download_android: 'Télécharger pour Android',
    download_ios: 'Télécharger pour iOS',

    // HERO
    hero_badge: 'La confiance de plus de 40 000 familles en Inde et en Europe',
    hero_headline: 'Des soins qui ressemblent à la',
    hero_headline_em: 'famille',
    hero_sub: 'Trouvez des infirmières, des aidants, des auxiliaires de vie et des conseillers vérifiés — sélectionnés, vérifiés et prêts à aider quand vous en avez le plus besoin.',
    hero_search_placeholder: 'Quel type de soins recherchez-vous ?',
    hero_search_btn: 'Rechercher',
    hero_trust_verified: 'Antécédents vérifiés',
    hero_trust_insured: 'Assuré',
    hero_trust_rating: 'Moy. 4,9 étoiles',

    // HERO FLOATING CARDS
    hero_card_badge: '✓ Infirmière vérifiée',
    hero_card_specialty: 'Soins post-chirurgie • 8 ans d\'exp.',
    hero_booking_status: 'Réservation confirmée',
    hero_booking_service: 'Soins post-chirurgie',
    hero_booking_time: 'Demain, 9h00–17h00',
    hero_booking_action: 'Soignant en route',
    hero_matched_label: 'Trouvé pour vous',
    hero_matched_distance: 'À 2,5 km',

    // QUICK FILTERS
    quickFilters: ['Soins aux personnes âgées', 'Infirmière post-opératoire', 'Nettoyage à domicile', 'Conseil', 'Garde d\'enfants', 'Compagnie'],

    // CATEGORIES SECTION
    cat_overline: 'Nos services',
    cat_heading: 'Tous les soins, sous un même toit',
    cat_sub: 'Du soutien médical à l\'aide quotidienne — choisissez les soins adaptés à votre vie.',
    cat_providers_label: 'prestataires',
    cat_explore: 'Explorer',

    cat1_title: 'Soutien médical',
    cat1_desc: 'Soins médicaux professionnels à domicile — de l\'infirmerie à la rééducation.',
    cat1_tags: ['Soins aux seniors', 'Post-opératoire', 'Démence', 'Soins intensifs'],

    cat2_title: 'Aide à domicile',
    cat2_desc: 'Une aide de confiance pour les tâches ménagères quotidiennes et les besoins familiaux.',
    cat2_tags: ['Nettoyage', 'Cuisine', 'Courses', 'Garde d\'enfants'],

    cat3_title: 'Soutien personnel',
    cat3_desc: 'Bien-être émotionnel, compagnie et accompagnement quand vous en avez besoin.',
    cat3_tags: ['Conseil', 'Coaching de vie', 'Compagnie', 'Soutien au deuil'],

    // FEATURED PROVIDERS
    featured_overline: 'Prestataires en vedette',
    featured_heading: 'La confiance des familles comme la vôtre',
    featured_view_all: 'Voir tous les prestataires',
    badge_verified: '✓ Vérifié',

    // STATS
    stat_families: 'Familles aidées',
    stat_rating: 'Note moyenne des prestataires',
    stat_caregivers: 'Soignants vérifiés',
    stat_satisfaction: 'Taux de satisfaction',

    // HOW IT WORKS
    how_heading: 'Des soins en 4 étapes simples',
    how_step1_title: 'Décrivez vos besoins',
    how_step1_desc: 'Dites-nous quel type de soins vous recherchez et vos exigences spécifiques.',
    how_step2_title: 'Parcourez les prestataires',
    how_step2_desc: 'Consultez les profils vérifiés, les notes et les avis des soignants.',
    how_step3_title: 'Connectez-vous et confirmez',
    how_step3_desc: 'Échangez avec les prestataires, discutez des détails et réservez en toute confiance.',
    how_step4_title: 'Soutien continu',
    how_step4_desc: 'Bénéficiez de soins de qualité avec notre garantie de satisfaction et un support 24h/24.',

    // TESTIMONIALS
    test_overline: 'Ce que disent les familles',
    test_heading: 'Histoires de confiance et de soins',

    // RECRUITMENT BANNER
    recruit_heading: 'Êtes-vous soignant, infirmier ou conseiller ?',
    recruit_body: 'Rejoignez la place de marché des soins à la croissance la plus rapide. Définissez votre propre planning et développez votre pratique.',
    perk_free: 'Inscription gratuite',
    perk_payouts: 'Paiements instantanés',
    perk_schedule: 'Vous gérez votre planning',
    perk_insurance: 'Assurance responsabilité civile incluse',
    btn_become_provider: 'Devenir prestataire',
    btn_learn_more: 'En savoir plus',

    // FINAL CTA
    cta_heading: 'Votre famille mérite les meilleurs soins',
    cta_body: 'Que vous ayez besoin d\'un soutien médical, d\'aide à la maison ou de quelqu\'un à qui parler — nous sommes là pour vous mettre en relation avec des soignants de confiance.',
    btn_find_today: 'Trouver un soignant aujourd\'hui',
    btn_browse_services: 'Parcourir tous les services',

    // FOOTER
    footer_tagline: 'Connecter les familles avec des soignants vérifiés et bienveillants en Inde et en Europe. Confiance, sécurité et connexion humaine — c\'est notre promesse.',
    footer_col_services: 'Services',
    footer_col_company: 'Entreprise',
    footer_col_support: 'Assistance',
    footer_copyright: '© 2025 Lotus Care. Tous droits réservés.',
    footer_healthcare: 'Soutien médical',
    footer_home_support: 'Aide à domicile',
    footer_personal_support: 'Soutien personnel',
    footer_elderly: 'Soins aux personnes âgées',
    footer_post_surgery: 'Soins post-chirurgie',
    footer_about: 'À propos',
    footer_careers: 'Carrières',
    footer_press: 'Presse',
    footer_blog: 'Blog',
    footer_partners: 'Partenaires',
    footer_help: 'Centre d\'aide',
    footer_safety: 'Centre de sécurité',
    footer_guidelines: 'Règles de la communauté',
    footer_contact: 'Nous contacter',
    footer_accessibility: 'Accessibilité',

    // CATEGORY PAGE
    breadcrumb_home: 'Accueil',
    providers_available_suffix: '+ prestataires disponibles',
    filters_title: 'Filtres',
    price_range_label: 'Fourchette de prix (€/h)',
    price_min_placeholder: 'Min',
    price_max_placeholder: 'Max',
    availability_label: 'Disponibilité',
    avail_today: 'Aujourd\'hui',
    avail_this_week: 'Cette semaine',
    avail_weekends: 'Week-ends',
    experience_label: 'Niveau d\'expérience',
    exp_junior: 'Junior (1-3 ans)',
    exp_senior: 'Senior (4-7 ans)',
    exp_expert: 'Expert (8+ ans)',
    specialization_label: 'Spécialisation',
    rating_label: 'Note',
    rating_4: '4★ et plus',
    rating_45: '4,5★ et plus',
    rating_5: '5★ uniquement',
    apply_filters_btn: 'Appliquer les filtres',
    providers_found_suffix: 'prestataires trouvés',
    sort_by_label: 'Trier par :',
    sort_relevant: 'Plus pertinent',
    sort_rating_opt: 'Mieux notés',
    sort_price: 'Prix le plus bas',
    sort_reviews: 'Plus d\'avis',

    // SPECIALIZATIONS
    spec_healthcare: ['Soins aux seniors', 'Post-opératoire', 'Démence', 'Soins intensifs', 'Kinésithérapie', 'Soins palliatifs'],
    spec_home_support: ['Nettoyage', 'Cuisine', 'Garde d\'enfants', 'Courses', 'Lessive', 'Animaux'],
    spec_personal_support: ['Conseil', 'Coaching de vie', 'Compagnie', 'Soutien au deuil', 'Thérapie familiale'],

    // SERVICE LISTING PAGE
    breadcrumb_healthcare: 'Soutien médical',
    sl_experience: 'expérience',
    sl_reviews: 'avis',
    sl_repeat_hire: '% de rebooking',
    sl_about_me: 'À mon sujet',
    sl_whats_included: 'Ce qui est inclus',
    sl_credentials: 'Diplômes et certifications',
    sl_reviews_title: 'Avis',
    sl_all_ratings: 'Toutes les notes',
    sl_5_stars: '5 étoiles',
    sl_4_stars: '4 étoiles',
    sl_3_stars: '3 étoiles',
    sl_stars: 'étoiles',
    sl_load_more: 'Charger plus d\'avis',
    sl_book_session: 'Réserver une séance',
    sl_book_sub: 'Choisissez un forfait et planifiez vos soins',
    sl_of_care: 'de soins',
    sl_select_date: 'Sélectionner une date',
    sl_book_now: 'Réserver maintenant',
    sl_message_provider: 'Contacter le prestataire',
    sl_safe_payment: 'Paiement sécurisé',
    sl_verified_provider: 'Prestataire vérifié',
    sl_free_cancel: 'Annulation gratuite (24h)',

    // BOOKING FLOW PAGE
    book_breadcrumb: 'Réserver',
    book_step1: 'Détails du service',
    book_step2: 'Planning',
    book_step3: 'Confirmer & payer',
    book_confirm_service: 'Confirmer votre service',
    book_of_care_included: 'de soins inclus',
    book_notes_label: 'Exigences spéciales ou notes (optionnel)',
    book_notes_placeholder: 'Informez le soignant de vos besoins particuliers, conditions médicales ou exigences spécifiques...',
    book_continue_schedule: 'Continuer vers le planning',
    book_choose_datetime: 'Choisir la date et l\'heure',
    book_select_date: 'Sélectionner une date',
    book_select_time: 'Sélectionner l\'heure de début',
    book_booking_type: 'Type de réservation',
    book_one_time: 'Ponctuel',
    book_weekly: 'Hebdomadaire',
    book_monthly: 'Mensuel',
    book_service_address: 'Adresse du service',
    book_full_address: 'Adresse complète',
    book_city: 'Ville',
    book_pincode: 'Code postal',
    book_back: 'Retour',
    book_continue_payment: 'Continuer vers le paiement',
    book_order_summary: 'Récapitulatif',
    book_service: 'Service',
    book_provider: 'Prestataire',
    book_date_time: 'Date et heure',
    book_duration: 'Durée',
    book_service_fee: 'Frais de service',
    book_platform_fee: 'Frais de plateforme',
    book_total: 'Total',
    book_promo_placeholder: 'Code promo',
    book_apply: 'Appliquer',
    book_payment_method: 'Mode de paiement',
    book_safe_payment: 'Paiement sécurisé',
    book_verified_provider: 'Prestataire vérifié',
    book_free_cancel: 'Annulation gratuite (24h)',
    book_not_selected: 'Non sélectionné',
    book_confirm_btn: 'Confirmer la réservation',
    book_confirm_heading: 'Réservation confirmée !',
    book_confirm_body: 'a été confirmée. Vous recevrez un e-mail de confirmation sous peu.',
    book_confirm_summary: 'Récapitulatif de réservation',
    book_confirm_tbc: 'À confirmer',
    book_back_home: 'Retour à l\'accueil',
    book_browse_providers: 'Voir plus de prestataires',

    // PROVIDER PROFILE PAGE
    pp_member_since: 'Membre depuis',
    pp_tab_overview: 'Aperçu',
    pp_tab_services: 'Services',
    pp_tab_reviews: 'Avis',
    pp_tab_credentials: 'Diplômes',
    pp_book_now: 'Réserver maintenant',
    pp_book_session: 'Réserver une séance',
    pp_message: 'Message',
    pp_verified: 'Vérifié',
    pp_top_rated: 'Mieux noté',
    pp_stat_bookings: 'Réservations totales',
    pp_stat_experience: 'Expérience',
    pp_stat_response: 'Temps de réponse',
    pp_stat_reviews: 'avis',
    pp_about: 'À mon sujet',
    pp_areas_served: 'Zones desservies',
    pp_languages: 'Langues',
    pp_view_details: 'Voir les détails',
    pp_load_more: 'Charger plus d\'avis',
    pp_identity_verified: 'Identité vérifiée',
    pp_identity_sub: 'Pièce d\'identité vérifiée par Lotus Care',
    pp_background_check: 'Vérification des antécédents',
    pp_background_sub: 'Effectuée en mars 2024',
    pp_starting_from: 'À partir de',
    pp_usually_responds: 'Répond généralement',
    pp_verified_checked: 'Vérifié et contrôlé',
  },
};
